import React, { useState, useEffect } from 'react';
import { ListGroup, ListGroupItem, Button, Card, CardBody, CardFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { startCase, sortBy } from 'lodash';
import { CardHeader, PseudoStates } from '@cordata/buffet';
import { all, spread } from 'axios';

import { authorizedInstance as axios, CardItemLimit } from '~/utils';

import ListGroupItemMedicalEvent from '../ListGroupItem';

const CardMedicalEvents = ({ medicalEvent }) => {
  const params = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState();

  useEffect(() => {
    all([
      axios
        .get(`/patients/${params.patient_id}/medical-events/${medicalEvent.attributes.medicalEventName}`),
      axios
        .get(`/patients/${params.patient_id}/foreign/medical-event`),
    ]).then(spread((n, f) =>
      [].concat(
        n.data.data,
        f.data.data.filter(ff =>
          ff.attributes.medicalEventName === medicalEvent.attributes.medicalEventName),
      ).map((mE) => {
        if (mE.type === 'nav-list-view-medical-event') {
          // eslint-disable-next-line
          mE.isForeign = true;

          // eslint-disable-next-line
          mE.attributes.detail = mE.attributes.detail && mE.attributes.detail.reduce((a, m) => {
            if (m) {
              const [key, value, ...rest] = m.split(',');

              // eslint-disable-next-line
              a[key] = value + rest.join(',');
            }

            return a;
          }, {});
        }

        return mE;
      })))
      .then(setData)
      .catch(setError)
      .then(() => setIsLoading(false));
  }, []);

  return (
    <Card header={false} footer={false}>
      <CardHeader
        color="primary"
        className="text-light"
        action={
          <Button
            size="sm"
            outline
            color="light"
            tag={Link}
            to={`/patients/${params.patient_id}/medical-events/${medicalEvent.attributes.medicalEventName}/add`}
          >
            <FontAwesomeIcon icon="plus" />
          </Button>
        }
      >
        {`${startCase(medicalEvent.attributes.medicalEventLabel)}s`}
      </CardHeader>

      <CardBody className="p-0">
        {!isLoading && !error ? (
          <ListGroup flush>
            {sortBy(data, ['attributes.eventDate']).reverse().slice(0, CardItemLimit).map(d => (
              <ListGroupItemMedicalEvent
                key={d.id}
                data={d}
                params={params}
                medicalEvent={medicalEvent}
              />
          ))}

            {!data.length && (
            <ListGroupItem>
              No {startCase(medicalEvent.attributes.medicalEventLabel)}s
            </ListGroupItem>
          )}
          </ListGroup>
      ) : (
        <PseudoStates isLoading={isLoading} error={error} />
      )}
      </CardBody>

      {data?.length > CardItemLimit &&
        <CardFooter
          tag={Link}
          to={`/patients/${params.patient_id}/medical-events/${medicalEvent.attributes.medicalEventName}`}
          className="text-center"
        >
          Show More ...
        </CardFooter>
      }
    </Card>
  );
};

CardMedicalEvents.propTypes = {
  medicalEvent: PropTypes.shape().isRequired,
};

export default CardMedicalEvents;
